import React from 'react';
import './ScanImageBox.scss';

export interface ScanImageBoxProps {
    imageUrl: string;
    className?: string;
    children?: React.ReactNode;
    alt?: string;
}

export const ScanImageBox = ({imageUrl, className = '', children, alt = ''}: ScanImageBoxProps): JSX.Element => (
    <div className={`scan-image-box ${className}`}>
        <img className='scan-image-box-img' src={imageUrl} alt={alt} />
        {children}
    </div>
);
